import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ProductTypeProp } from '../../../../shared/utils/prop-types/prop-types';
import sortByName from '../../../../shared/utils/sort-by-name/sort-by-name';
import { shopAction } from '../../utils/analytics';
import { getCategoryURL } from '../../utils/category-page-utils';

import './category-grid.scss';

function CategoryGrid(props) {
  const {
    className,
    categories,
    parentCategory,
    productType,
    showStaggeredURL = false
  } = props;

  function validCategory(category) {
    return category?.catalogURL && category?.name;
  }
  return (
    <div className={className} styleName="container">
      <div data-testid="grid" styleName="grid">
        {Array.isArray(categories) &&
          categories
            .filter(validCategory)
            .sort(sortByName)
            .map((category, index) => {
              const thumbnailUrl = category?.thumbnail?.url || '';
              const thumbnailAltText =
                category?.thumbnail?.altText || category?.name;

              return (
                <Link
                  key={`${thumbnailAltText}-${index}`}
                  onClick={() =>
                    shopAction({
                      category,
                      isGrid: true,
                      parentCategory,
                      productType
                    })
                  }
                  styleName="category-logo"
                  to={getCategoryURL(category.catalogURL, showStaggeredURL)}
                >
                  {thumbnailUrl && (
                    <img
                      alt={thumbnailAltText}
                      height={55}
                      src={thumbnailUrl}
                      width={165}
                    />
                  )}
                  {!thumbnailUrl && (
                    <div styleName="alt-text">{thumbnailAltText}</div>
                  )}
                </Link>
              );
            })}
      </div>
    </div>
  );
}

CategoryGrid.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      catalogURL: PropTypes.string.isRequired,
      thumbnail: PropTypes.shape({
        altText: PropTypes.string,
        url: PropTypes.string
      })
    })
  ),
  className: PropTypes.string,
  parentCategory: PropTypes.object,
  productType: ProductTypeProp,
  showStaggeredURL: PropTypes.bool
};

export default React.memo(CategoryGrid);
